import React from 'react'
import Select from 'react-select';
import { useStateValue } from '../../StateProvider';
import {  getDefaultValue, getSelectedTheme } from '../../utils'

export default function SelectGender({ callback, width, value , placeholder}) {

    var theme = getSelectedTheme();
    //alert(value)


    const customStyles = {
        control: (base, state) => ({
            ...base,

            background: theme === "light" ? "#f7f7f7" : "transparent",
            // match with the menu
            borderRadius: 25,
            // Overwrittes the different states of border
            borderColor: theme === "light" ? "#dee2e6" : "#424240",
            // Removes weird border around container
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
                // Overwrittes the different states of border
                borderColor: theme === "dark" ? "#424240" : "#dee2e6"
            }
        }),
        menu: base => ({
            ...base,
            width: width ? width : "150px",
            '*::-webkit-scrollbar': {
                width: '0.5em'
            },
            '*::-webkit-scrollbar-track': {
                '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
            },
            '*::-webkit-scrollbar-thumb': {
                backgroundColor: theme === "dark" ? '#282828' : "#c9c9c9",
                outline: theme === "dark" ? '1px solid #272727' : '1px solid #ddd'
            },
            marginLeft: "16px",
            boxShadow: theme === "dark" ? "1px 1px 1px 1px #0e0e0e80" : "2px 3px 3px 1px #ccc",
            // override border radius to match the box
            borderRadius: 0,
            borderBottomRightRadius: 5,

            borderBottomLeftRadius: 5,
            // kill the gap
            marginTop: 0,
            //borderTop: "3px solid #454542",
            backgroundColor: theme === "light" ? "#f9f9f9" : "#191a1c",
            opacity: "0.97",
            zIndex: 10000,

        }),
        menuList: base => ({
            ...base,
            // kill the white space on first and last option
            padding: 0,
            "&:hover": {
                backgroundColor: theme === "light" ? "#f9f9f9" : "#191a1c",
                borderBottomRightRadius: 5,
                borderBottomLeftRadius: 5,
                transition: "all 0.5s ease-out"
            }
        }),
        option: (base, state) => {


            let backgroundColor = "transparent";

            if (state.isSelected) {
                //backgroundColor = theme === "light" ? "#ccc" :"#454542";
            }

            if (state.isFocused) {
                backgroundColor = theme === "light" ? "#ccc" : "#282828";
            }
            if (state.isActive) {
                // backgroundColor = theme === "light" ? "#ccc" :"#454542";
            }

            return {
                ...base,
                color: theme === "light" ? "#282828" : "#ccc",
                fontSize: "14px",
                backgroundColor,
                transition: "all 0.5s ease-out"
            };
        },
        singleValue: (base) => ({
            ...base,
            color: theme === "light" ? "#1a1a1a" : "#e8e8e8",
        }),
        placeholder: (base) => ({
            ...base,
            color: theme === "light" ? "#6c757d" : "#9c9c9c",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 10060 }),

    };

    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x=>x.key == str );
    
        if (translate) return getDefaultValue(translate);
        else return "#" + str;
      };


    var options = [
        
        {
            label: translate("Female"),
            value: "1"
        },
        {
            label: translate("Male"),
            value: "0"
        },
        {
            label: translate("Other"),
            value: "2"
        }
    ]

    const handleSelect = (e) => {
        callback("gender", e && e.value)
    }

    const selectedOption =
        value === null || value === undefined || value === ''
            ? null
            : options.find((o) => String(o.value) === String(value)) ?? null;

    return (
        <>
            <div className="filter-select kfont">
                <Select
                    classNamePrefix="kt-rs-gender"
                    className="kt-react-select"
                    instanceId="select-gender"
                    inputId="select-gender-input"
                    options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder ? placeholder : "Gender"}
                    isClearable={false}
                    value={selectedOption}
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                    menuPosition="fixed"
                    menuPlacement="auto"
                />
            </div>

        </>
    )
}
